import sanitizeHtml from 'sanitize-html';

/**
 * Given a source string which may contain HTML tags, return the raw text.
 * @param {string} source - The source string from which to strip tags.
 * @returns {string} - The modified source.
 */
export default function stripTags(source) {
  return sanitizeHtml(
    source,
    {
      allowedTags: [],
    }
  );
}
